/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Wechat_App_IdInputs */

const en_admin_settings_fields_wechat_app_id = /** @type {(inputs: Admin_Settings_Fields_Wechat_App_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AppID`)
};

const zh_admin_settings_fields_wechat_app_id = /** @type {(inputs: Admin_Settings_Fields_Wechat_App_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AppID`)
};

/**
* | output |
* | --- |
* | "AppID" |
*
* @param {Admin_Settings_Fields_Wechat_App_IdInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_wechat_app_id = /** @type {((inputs?: Admin_Settings_Fields_Wechat_App_IdInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Wechat_App_IdInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_wechat_app_id(inputs)
	return zh_admin_settings_fields_wechat_app_id(inputs)
});
export { admin_settings_fields_wechat_app_id as "admin.settings.fields.wechat_app_id" }